import { Action as SessionAction } from './session/actions'
import { Action as CapabilitiesAction } from './capabilities/actions'

export const ACTION = {
  LOAD_DEFAULT_SHIPPER: 'LOAD_DEFAULT_SHIPPER@basket',
  RESTORE_FROM_SESSION_STATE: 'RESTORE_FROM_SESSION_STATE@basket',
} as const

type LoadDefaultShipperAction = {
  type: typeof ACTION.LOAD_DEFAULT_SHIPPER
}

export const loadDefaultShipper = (): LoadDefaultShipperAction => ({
  type: ACTION.LOAD_DEFAULT_SHIPPER,
})

type RestoreFromSessionStateAction = {
  type: typeof ACTION.RESTORE_FROM_SESSION_STATE
}

export const restoreFromSessionState = (): RestoreFromSessionStateAction => ({
  type: ACTION.RESTORE_FROM_SESSION_STATE,
})

export type Action = LoadDefaultShipperAction | SessionAction | CapabilitiesAction | RestoreFromSessionStateAction
